export default "__VITE_ASSET__f0568563__"